import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import SchoolSearch from '../../components/schoolSearch/schoolSearchComponent'
import { State } from '../../../redux/reducers/'
import { actionCreators } from '../../../redux/reducers/autoSuggest/autoSuggestReducer'
import { actionCreators as sagaActionCreators } from '../../../redux/sagas'

// Global State
export function mapStateToProps (state: State, props): Values {
  return {
    suggestions: state.autoSuggest.districtSuggestions,
    startingList: state.autoSuggest.districts
  }
}
// In Object form, each funciton is automatically wrapped in a dispatch
export const propsMapping: Callbacks = {
  updateSuggestions: actionCreators.updateDistrictSuggestions,
  resetSchools: actionCreators.resetSchools,
  fetchDistricts: compose(
    sagaActionCreators.districtSchoolActionCreators.fetchDistricts
  ),
  onSuggestionSelected: compose(
      sagaActionCreators.districtSchoolActionCreators.fetchSchools
  )
}

// export default connect(mapStateToProps, propsMapping)(SchoolSearch)

export default compose(
  connect(mapStateToProps, propsMapping),
  lifecycle({
    componentDidMount: function () {
      if (this.props.fetchDistricts) {
        this.props.fetchDistricts()
      }
      if (this.props.resetSchools) {
        this.props.resetSchools()
      }
    }
  })
)(SchoolSearch)



// WEBPACK FOOTER //
// ./src/forms/containers/districtSearch/districtSearchContainer.js